import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TransactionDialogComponent } from './transaction.dialog';
import { TransactionsService } from '../../services/transactions.service';

@Injectable({
  providedIn: 'root'
})
export class ProofViewerDialogService {

    public confirmEvidence: boolean = false;

    constructor(
        public dialog: MatDialog,
        public transactionService: TransactionsService) {}

    public open(transactionHash: string, index: number, dataSource: any, callback: any, pendingEvidence?: any) {
        return this.transactionService.get(transactionHash).subscribe((result) => {
            let dialog = this.dialog.open(TransactionDialogComponent, {
                height: '100vh',
                width: '90vw',
                maxHeight: '100%',
                maxWidth: '90vw',
                data: {
                    transactionHash,
                    index,
                    dataSource,
                    pendingEvidence
                }
            });

            dialog.afterClosed().subscribe(r => {
                callback();
            })
        });
    }
}
